/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Miniapp_Login_Subtitle1Inputs */

const vi_sitesettings_miniapp_login_subtitle1 = /** @type {(inputs: Sitesettings_Miniapp_Login_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dòng phụ màn đăng nhập`)
};

/**

* @param {Sitesettings_Miniapp_Login_Subtitle1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_miniapp_login_subtitle1 = /** @type {((inputs?: Sitesettings_Miniapp_Login_Subtitle1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Miniapp_Login_Subtitle1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_miniapp_login_subtitle1(inputs)
});
export { sitesettings_miniapp_login_subtitle1 as "siteSettings_miniapp_login_subtitle" }